// Multi-Tenant-Konfiguration: Brand-Auswahl per Hostname.
// Hostname → Brand-Object. Lokal (localhost, 127.0.0.1) → 'kids' als Default.

export const BRANDS = {
  kids: {
    id: 'kids',
    // Header: futurhinos.kids (mit Pink-Span)
    nameBase: 'futurhinos',
    nameSuffix: '.kids',
    // Volltext fuer Seitenkopf/CTAs
    fullName: 'Futurhinos for Kids',
    marketingUrl: 'https://futurhinos-kids.de',
    domain: 'join.futurhinos-kids.de',
    // Aktive Bereiche / Routes
    routes: {
      kursplan: true,
      schnuppern: true,    // Schnupper-Pass + Kennenlerntermin
      events: true,
      feriencamps: true,
      geburtstage: true,
      coaching: false,     // AI-only
    },
    hero: {
      title: 'Willkommen bei',
      titleEm: 'Futurhinos for Kids',
      subtitle: 'Entdecke unsere spannenden Kurse rund um KI, Robotik und digitale Kreativität — starte mit dem Schnupper-Pass oder buche direkt einen Kennenlerntermin.',
      ctaPrimary: { label: 'Schnupper-Pass starten', to: '/schnuppern' },
      ctaSecondary: { label: 'Events entdecken', to: '/events' },
    },
  },
  ai: {
    id: 'ai',
    nameBase: 'futurhinos',
    nameSuffix: '.ai',
    fullName: 'Futurhinos AI',
    marketingUrl: 'https://futurhinos-ai.com',
    domain: 'join.futurhinos-ai.com',
    routes: {
      kursplan: false,
      schnuppern: false,
      events: true,
      feriencamps: false,
      geburtstage: false,
      coaching: true,      // 1:1 Coaching + Pakete
    },
    hero: {
      title: 'Willkommen bei',
      titleEm: 'Futurhinos AI',
      subtitle: 'KI im Alltag oder selber bauen mit KI — 1:1 Coaching und Workshops für Erwachsene und Unternehmen.',
      ctaPrimary: { label: '1:1 Kennenlerntermin', to: '/coaching/kennenlernen' },
      ctaSecondary: { label: 'Coaching-Pakete', to: '/coaching' },
    },
  },
};

export function detectBrand() {
  if (typeof window === 'undefined') return BRANDS.kids;
  const host = window.location.hostname.toLowerCase();
  if (host.includes('futurhinos-ai')) return BRANDS.ai;
  return BRANDS.kids;
}
